import React from 'react';
import ProspeccaoBoard from './ProspeccaoBoard';

const ProspeccaoPage: React.FC = () => <ProspeccaoBoard />;

export default ProspeccaoPage;

